// extracted by mini-css-extract-plugin
module.exports = {"split":"_1678bwbEqQ32dlzNLbMiLJ--split"};